function _ts() {
  return new Date().toISOString().slice(0, 19).replace(/[T:]/g, '-');
}

async function _download(response, filename) {
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export function exportJSON({ data, filename }) {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}_${_ts()}.json`;
  a.click();
  URL.revokeObjectURL(url);
}

export async function exportCSV({ endpoint, data, fields, filename, periods, sheets }) {
  const isNewFormat = sheets !== undefined;
  if (!isNewFormat && !periods && !data?.length) return;
  const body = isNewFormat
    ? { filename, sheets }
    : periods
      ? { filename, periods }
      : { filename, fields, data };
  const response = await fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
  if (!response.ok) {
    console.error('CSV export failed:', response.statusText);
    return;
  }
  await _download(response, `${filename}_${_ts()}.xlsx`);
}

async function _captureChartImage(chartContainerId) {
  try {
    const el = document.getElementById(chartContainerId);
    const svg = el?.querySelector('svg.recharts-surface');
    if (!svg) return '';
    const bbox = svg.getBoundingClientRect();
    const w = Math.round(bbox.width);
    const h = Math.round(bbox.height);
    const clone = svg.cloneNode(true);
    clone.setAttribute('width', w);
    clone.setAttribute('height', h);
    clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    const svgData = new XMLSerializer().serializeToString(clone);
    const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(svgBlob);
    const img = new Image();
    await new Promise((resolve, reject) => {
      img.onload = resolve;
      img.onerror = reject;
      img.src = url;
    });
    const scale = 2;
    const canvas = document.createElement('canvas');
    canvas.width = w * scale;
    canvas.height = h * scale;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#0f1117';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.scale(scale, scale);
    ctx.drawImage(img, 0, 0, w, h);
    URL.revokeObjectURL(url);
    return canvas.toDataURL('image/png').split(',')[1];
  } catch (err) {
    console.warn('Chart capture failed:', err.message);
    return '';
  }
}

export async function exportPDF({ endpoint, data, fields, filename, chartContainerId, title, summaryItems, tables }) {
  const isNewFormat = summaryItems !== undefined;
  if (!isNewFormat && !data?.length) return;

  const chartImage = await _captureChartImage(chartContainerId);

  const body = isNewFormat
    ? { filename, title, chartImage, summaryItems: summaryItems ?? [], tables: tables ?? [] }
    : { filename, title, chartImage, fields, data };

  const response = await fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
  if (!response.ok) {
    console.error('PDF export failed:', response.statusText);
    return;
  }
  await _download(response, `${filename}_${_ts()}.pdf`);
}